var Vue = require('vue');
var EntriesList = require('./components/EntriesList.vue').default;
var Columnator = require('../../lib/columnator.js');
var IndexView = require('../../lib/index-view.js');
var sanitize = require('@/lib/utils.js').sanitize;
var store = require('@/lib/store').default;

module.exports = function() {
  const entriesList = new Vue({
    el: '#entries-list',
    components: {
      'entries-list': EntriesList
    },
    store
  });

  $(document).one('pjax:end', () => {
    entriesList.$destroy();
  });

  new Columnator();
  new IndexView();


  // Autocomplete
  var entrantField = $('#entrant');

  entrantField.select2({
    ajax: {
      url: '/entry/autocomplete',
      dataType: 'json',
      delay: 250,
      data: function(searchTerm) {
        return {
          name: searchTerm
        }
      },
      results: function(data) {
        return {
          results: data
        }
      },
      cache: true
    },
    formatResult: function(user) {
      return sanitize(user.fullName);
    },
    formatSelection: function(user) {
      return sanitize(user.fullName);
    },
    initSelection: function(element, callback) {
      var id = $(element).val();

      if (id !== '') {
        $.ajax('/entry/entrant_user/' + id, {
          dataType: 'json'
        }).done(function(data) {
          callback(data);
        });
      }
    },
    minimumInputLength: 3
  });
};
